<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="required">{{ $t('productAssembly.product') }}</label>
            <a-select
              v-model="model.assembly_sale_code_id"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :options="assemblyProduct"
              class="ts-w-full"
              @change="findData"
            ></a-select>
            <div class="validate" v-if="errors.has('assembly_sale_code_id')">
              {{ errors.first('assembly_sale_code_id') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-md-5">
            <LeftBox v-model="model" />
          </div>
          <div class="col-md-7">
            <RightBox v-model="model" :validate="errors" />
            <div class="validate" v-if="errors.has('other_product_id_list')">
              {{ errors.first('other_product_id_list') }}
            </div>
          </div>
        </div>
        <div class="row form-group">
          <div
            class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
          >
            <ts-button @click.prevent="$emit('cancel')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              color="primary"
              outline
              :waiting="waiting_new"
              @click.prevent="onSaveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              :waiting="waiting"
              @click.prevent="onSave"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import LeftBox from './left-box'
import RightBox from './right-box'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  components: {
    LeftBox,
    RightBox
  },
  props: ['saleCodeId'],
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        assembly_sale_code_id: null,
        other_product_id_list: []
      }
    }
  },
  created() {
    this.fetchData()
    this.model.assembly_sale_code_id = this.saleCodeId
  },
  computed: {
    assemblyProduct() {
      return this.$store.state.product.assembly.productAssembly
        .filter(a => a.product_type_id == 1)
        .map(el => ({
          value: el.pro_sale_code_id,
          label: el.barcode +' - '+el.name
        }))
    }
  },
  methods: {
    ...mapActions('product/assembly', ['find', 'store']),
    async fetchData() {
      this.loading = true
      await this.$store
        .dispatch('product/assembly/getAssembly')
        .finally(() => (this.loading = false))
      await this.findData()
    },
    async findData() {
      this.model.other_product_id_list = []
      this.loading = true
      await this.find(this.model.assembly_sale_code_id)
        .then(response => {
          if (response.data.length > 0) {
            this.model.other_product_id_list = response.data
          }
        })
        .finally(() => (this.loading = false))
    },
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput() {
      this.model.assembly_sale_code_id = null
      this.model.other_product_id_list = []
    }
  },
  watch: {
    saleCodeId: function(value) {
      this.model.other_product_id_list = []
      this.model.assembly_sale_code_id = value
      this.findData()
    }
  }
}
</script>
